import React from 'react'
import { GrayWrapper, RateNote, ValueView } from './style'
import LoadingBar from '../../components/LoadingBar'

interface RateSummaryProps {
  exchangeRate: string
  isLoading: boolean
}

/** The all-in rate of a conversion: what arrives per unit sent, fees included. */
const RateSummary = ({ exchangeRate, isLoading }: RateSummaryProps): JSX.Element => {
  return (
    <GrayWrapper style={{ flexDirection: 'column' }}>
      <ValueView>
        <span>Rate</span>
        {isLoading
          ? (
            <LoadingBar style={{ height: 15.5, width: 150 }}/>
          )
          : (
            <span>{exchangeRate}</span>
          )}
      </ValueView>
      <RateNote>All fees are included in the rate.</RateNote>
    </GrayWrapper>
  )
}

export default RateSummary
